import React, { FC } from 'react'

import { Avatar, Link, styled } from '@mui/material'

interface MarkdownLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string
  children?: React.ReactNode
}

const StyledLink = styled(Link)({
  display: 'inline-flex',
  alignItems: 'baseline',
  textDecoration: 'none',
})

export const MarkdownLink: FC<MarkdownLinkProps> = ({ href = '', children, ...props }) => {
  let domain = ''

  try {
    domain = new URL(href).hostname
  } catch {
    domain = href
  }

  const faviconUrl = domain ? `https://www.google.com/s2/favicons?domain=${domain}` : ''

  return (
    <StyledLink
      color="primary.main"
      variant="body1"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={typeof children === 'string' ? children : href}
      {...props}
    >
      {faviconUrl && (
        <Avatar
          component={'span'}
          src={faviconUrl}
          alt={domain}
          sx={{ width: 14, height: 14, mr: 0.5, alignSelf: 'center' }}
        />
      )}
      {children}
    </StyledLink>
  )
}

export default MarkdownLink
